import React from "react";
import { useEffect } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { newData } from "./PrivacyData";
import PrivacyAccordion from "./PrivacyAccordion";
// import BackgroundBrundcrumb from "../../assets/images/IZB/BackgroundBrundcrumb.png";

const PrivacyPolicy = () => {
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/BackgroundBrundcrumb.png";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb Heading="Privacy Policy" img={BackgroundBrundcrumb} />
      <div className="container mt-5">
        <div className="faq-style1__content">
          <ul className="accordion-box">
        
             <PrivacyAccordion  />
          
          </ul>
        </div>
      </div>
      <br/>
      <div className="col-xl-12 justify-content-center"></div>
      <AllAcountsSection />
    </>
  );
};

export default PrivacyPolicy;
